import { SportsRugbySharp } from '@material-ui/icons'

const styles = theme => ({
  MuiIconButton: {
    root: {
      padding: '14px'
    }
  },
  popout: {
    '& $eventTitle': {
      '@media (max-width: 568px)': {
        fontSize: '1rem'
      }
    }
  },

  isFullscreen: {
    '& $videoControls': {
      padding: 0
    }
  },
  videoControls: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '85%',
    zIndex: 2,
    paddingTop: 60,
    paddingBottom: theme.spacing(2),
    maxHeight: '100%'
  },
  liveAccessProgress: {
    height: 102,
    width: 102,
    flexShrink: 0,
    padding: 12,
    marginLeft: theme.spacing(-2),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  progress: {
    height: [60, '!important'],
    width: [60, '!important'],
    color: 'white'
  },
  liveNowBox: {
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    maxWidth: 256,
    '@media (max-width: 767px)': {
      maxWidth: 166
    }
  },
  liveNowBoxHidden: {
    visibility: 'hidden'
  },
  liveNowText: {
    paddingRight: '15px',
    textTransform: 'uppercase',
    fontSize: '1.3125rem',
    '@media (max-width: 767px)': {
      fontSize: '1rem',
      lineHeight: '1.4rem'
    }
  },
  liveNowTextFocused: {
    width: '80%',
    borderColor: '#80bdff',
    boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
    backgroundColor: '#00FF00'
  },
  liveEventText: {
    color: theme.palette.royal.main,
    textTransform: 'uppercase',
    marginBottom: theme.spacing(),
    '@media (max-width: 767px)': {
      fontSize: '0.8rem',
      marginBottom: 0
    }
  },
  eventTitle: {
    color: 'white',
    fontSize: '2.625rem',
    lineHeight: '1.1',
    maxWidth: '600px',
    marginBottom: theme.spacing(3),
    textTransform: 'uppercase',
    '@media (max-width: 767px)': {
      fontSize: '2rem',
      marginBottom: theme.spacing()
    }
  },
  startingSoonTitle: {
    color: 'white',
    fontSize: '1.5rem',
    lineHeight: '1.1',
    maxWidth: '600px',
    marginBottom: theme.spacing(3),
    textTransform: 'uppercase',
    '@media (max-width: 767px)': {
      fontSize: '2rem',
      marginBottom: theme.spacing()
    }
  },
  detailsLine: {
    color: 'white',
    display: 'flex',
    marginBottom: theme.spacing(2),
    '& > svg': {
      marginRight: theme.spacing(2)
    },
    '& > h3': {
      fontWeight: 400,
      fontSize: 17
    }
  },
  address: {
    fontWeight: 700
  },
  cityStateZip: {
    fontWeight: 400
  },
  playButton: {
    color: 'white',
    marginLeft: '2px',
    marginRight: '10px',
    width: 275,
    height: 100,
    backgroundColor: 'rgba(211, 211, 211, 0.25)',
    borderRadius: '500px',
    '&:hover': {
      backgroundColor: 'rgba(211, 211, 211, 0.5)'
    },
    '&:focus': {
      outline: 'white solid 4px'
    }
  },
  playButtonFocused: {
    color: 'white',
    marginLeft: theme.spacing(-6),
    width: 300,
    height: 100,
    boxShadow: '0 0 0 2pt red',
    outline: 'none'
  },
  playIcon: {
    paddingRight: '10px',
    marginRight: '20x',
    fontSize: 78,
    '@media (max-width: 767px)': {
      fontSize: 54
    }
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/LiveVideo/VideoControls/styles.js